/**
 * Audio Theme Registry
 *
 * Maps audio cue names to MP3 asset URLs per variant. Mirrors the visual
 * theme variant pattern: pick a variant → look up the file for each cue.
 * Add a new variant by appending an entry here; no other code changes
 * required (Settings UI reads `audioVariants`, the player resolves via
 * `audioRegistry`).
 */

export type AudioCue =
  | 'cot.narration'
  | 'cot.tool'
  | 'thread.request'
  | 'thread.response'
  | 'task.created'
  | 'task.completed';

export type AudioVariant = 'default';

export const audioVariants: ReadonlyArray<{
  variant: AudioVariant;
  label: string;
  description: string;
}> = [
  {
    variant: 'default',
    label: 'Default',
    description: 'Subtle ticks and chimes',
  },
];

export const audioRegistry: Record<AudioVariant, Record<AudioCue, string>> = {
  default: {
    'cot.narration': '/sounds/default/cot-narration.mp3',
    'cot.tool': '/sounds/default/cot-tool.mp3',
    'thread.request': '/sounds/default/thread-request.mp3',
    'thread.response': '/sounds/default/thread-response.mp3',
    'task.created': '/sounds/default/task-created.mp3',
    'task.completed': '/sounds/default/task-completed.mp3',
  },
};

export const allCues: ReadonlyArray<AudioCue> = [
  'cot.narration',
  'cot.tool',
  'thread.request',
  'thread.response',
  'task.created',
  'task.completed',
];
